import React from "react"
import clsx from "clsx"

import classes from "./TnSidebarButton.module.scss"

const TnSidebarButton = props => {
  const { openSidebar, setOpenSidebar } = props

  return (
    <div
      className={classes["bars"]}
      onClick={() => setOpenSidebar(prev => !prev)}
    >
      <div className={classes["bar"]} />
      <div
        className={clsx(
          classes["bar"],
          !openSidebar && classes["bar-fullwidth"]
        )}
      />
      <div
        className={clsx(
          classes["bar"],
          !openSidebar && classes["bar-fullwidth"]
        )}
      />
    </div>
  )
}

export default TnSidebarButton